module.exports = __webpack_public_path__ + "img/idea.e3e6e140.jpg";